define("shared/components/shared/button/update-card", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/service", "@glimmer/component", "ember-concurrency", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _service, _component2, _emberConcurrency, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"ember-concurrency",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Ui::Button
    @isDisabled={{or this.handleToken.isRunning @isDisabled}}
    @onClick={{this.openCheckout}}
    @text={{@buttonText}}
    @variant={{this.variant}}
    ...attributes
  />
  */
  {
    "id": "GBN5QXPa",
    "block": "[[[8,[39,0],[[17,1]],[[\"@isDisabled\",\"@onClick\",\"@text\",\"@variant\"],[[28,[37,1],[[30,0,[\"handleToken\",\"isRunning\"]],[30,2]],null],[30,0,[\"openCheckout\"]],[30,3],[30,0,[\"variant\"]]]],null]],[\"&attrs\",\"@isDisabled\",\"@buttonText\"],false,[\"shared/ui/button\",\"or\"]]",
    "moduleName": "shared/components/shared/button/update-card.hbs",
    "isStrictMode": false
  });
  let UpdateCardComponent = _exports.default = (_class = class UpdateCardComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "errors", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _initializerDefineProperty(this, "stripe", _descriptor4, this);
      _defineProperty(this, "handleToken", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (token) {
          try {
            yield this.args.handleCard.perform(token);
            this.alerts.success(this.intl.t('alerts.account.subscription.billing.update_card.success'));
          } catch (error) {
            this.alerts.warning(this.intl.t('alerts.account.subscription.billing.update_card.error'));
            this.errors.log(JSON.stringify(error));
          }
        }
      }), null, "handleToken", "drop"));
    }
    get variant() {
      return this.args.variant || 'outline';
    }
    openCheckout() {
      this.stripe.openCheckout(this.args.billingEmail).then(token => this.handleToken.perform(token));
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "stripe", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "openCheckout", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openCheckout"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, UpdateCardComponent);
});